import { withStyles, makeStyles } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";

const useStyles = makeStyles((theme: any) => ({
  collectionItem: (props: any) => ({
    position: "relative",
    width: props.matches ? "18rem" : "100%",
    height: props.matches ? "max-content" : "100%",
  }),
  imageContainer: (props: any) => ({
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: props.matches ? "18rem" : "auto",
    height: props.matches ? "18rem" : "9rem",
  }),
  linkToItemDetail: {
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 0,
  },
  noImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    backgroundColor: theme.whiteSmokeColor,
  },
  image: (props: any) => ({
    width: "100%",
    height: "100%",
    background: `no-repeat center/100% url(${
      props.image?.url ? props.image?.url : props.image
    })`,
    backgroundSize: "cover",
    backgroundColor: theme.whiteSmokeColor,
  }),
  badgeContainer: (props: any) => ({
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    justifyContent: "flex-start",
    height: props.matches ? "2rem" : "1.2rem",
  }),
  badge: (props: any) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: props.matches ? "6rem" : "3.5rem",
    fontSize: props.matches ? "0.8rem" : "0.5rem",
    textTransform: "uppercase",
  }),
  soldoutBadge: {
    color: theme.darkSlateGrayColor,
    backgroundColor: theme.khakiColor,
  },
  popularBadge: {
    color: theme.snowColor,
    backgroundColor: theme.darkSlateGrayColor,
  },
  onsaleBadge: {
    color: theme.lightCoralColor,
    backgroundColor: theme.linenColor,
  },
  infoContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    marginTop: "1rem",
  },
  brand: (props: any) => ({
    fontSize: props.matches ? "0.9rem" : "0.8rem",
    fontWeight: "bold",
  }),
  name: (props: any) => ({
    fontSize: props.matches ? "1rem" : "0.8rem",
  }),
  ratingContainer: {
    display: "flex",
    height: "max-content",
  },
  rating: {
    display: "flex",
    alignItems: "center",
  },
  numberOfReviews: {
    display: "flex",
    alignItems: "center",
    marginLeft: "0.2rem",
    color: theme.grayColor,
  },
}));

export const StyledRating = withStyles((theme: any) => ({
  iconFilled: {
    color: theme.darkSlateGrayColor,
  },
  iconEmpty: {
    color: theme.whiteSmokeColor,
  },
}))(Rating);

export default useStyles;
